import { render, staticRenderFns } from "./ShoppingListsHeader.vue?vue&type=template&id=5f4203a8&"
import script from "./ShoppingListsHeader.vue?vue&type=script&lang=js&"
export * from "./ShoppingListsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports